import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CssBaseline, ThemeProvider } from "@mui/material";
import adminTheme from "./theme/adminTheme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={adminTheme}>
      <CssBaseline /> {/* Ensures consistent baseline styling */}
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Performance measurement
reportWebVitals();
